import { Component, Input, OnInit } from '@angular/core';
import { Select } from '@ngxs/store';
import { Observable } from 'rxjs';
import { VillageState } from 'src/app/state/village.state';

@Component({
  selector: 'app-village-label',
  template: `<span *ngIf="villageLabel$ | async as label">{{
    showTitlecase ? (label | titlecase) : label
  }}<span *ngIf="plural">s</span></span>`,
})
export class VillageLabelComponent implements OnInit {
  @Select(VillageState.configVillageLabel) villageLabel$: Observable<string>;

  @Input() showTitlecase = false;
  @Input() plural = false;
  constructor() {}

  ngOnInit() {}
}
